import React, { useReducer, useEffect } from 'react';
import { Modal, ModalBody } from 'reactstrap'
import { CusButton } from '../../Components/From/Button';
import { FormattedMessage } from 'react-intl';
import PerfectScrollbar from 'react-perfect-scrollbar';
import cls from 'classnames';

const reducer = (state, { type, payload }) => {
  let newState = { ...state };
  switch (type) {
    case 'UPDATE_STATE':
      payload.forEach(i => {
        newState[i.key] = i.val;
      });
      return newState;
    default:
      return newState;
  }
};

function Tool__CusFilter({
  selectedItems,
  selectedVeganItems,
  onClose,
  onSelectItem,
  tagGroup
}) {
  const [state, dispatch] = useReducer(reducer, {
    selectedItem:{
      allergen:pickDefaultTag(),
      vegan:pickDefaultVegan()
    }
  });

  function pickDefaultTag() {
    if (selectedItems) {
      return selectedItems;
    } else {
      // const whichTaste = takeoutState ? takeoutTaste : dineInTaste;
      // const defaultTaste = whichTaste.filter(def => def.preset).map(e => e.id);
      return [];
    }
  }

  function pickDefaultVegan() {
    if (selectedVeganItems) {
      return selectedVeganItems;
    } else {
      // const whichTaste = takeoutState ? takeoutTaste : dineInTaste;
      // const defaultTaste = whichTaste.filter(def => def.preset).map(e => e.id);
      return [];
    }
  }

  const allergenList = tagGroup.allergenMenu || [];
  const veganList = tagGroup.vegetarian || [];
  return (
    <Modal
      isOpen
      fade={false}
      backdrop={false}
    >
      <div className="Tool Tool__CusFilter d-flex justify-content-center align-items-center">
        <div className="Tool__CusFilter__content d-flex flex-column p-4">
          <div className="Tool__CusFilter__title pe-5" >
            <FormattedMessage id="popup.filter" style={{float:"left"}}/>    
            <span  style={{float:"right"}}>
              <CusButton.Red
                children={
                  <FormattedMessage id="popup.cancelAll" />
                }
                className="btn-block"
                onClick={() => {
                  dispatch({
                    type: 'UPDATE_STATE',
                    payload: [{ key: 'selectedItem', val:{allergen:[],vegan:[]}}]
                  });
                }}
              />
            </span>               
          </div>         
          <hr style={{marginTop: "8px", marginBottom:"8px"}}/>
          <div className="Tool__CusFilter__optionContent pb-3 clearfix" style={{ height: 0 }}>
            <PerfectScrollbar className="p-0" >
                <div className="Tool__CusFilter__subtitle pb-2">
                  <FormattedMessage id="popup.allergen" />
                </div>
                <div className="mb-1 d-inline-block">
                {(() => {
                  if (!allergenList) return null;
                  return allergenList.map((e, index) => (
                    <a
                      key={index}
                      className={cls(
                        'Tool__CusFilter__option p-1 row align-items-center justify-content-center',
                        state.selectedItem.allergen.find(f => f === e.id)
                          ? 'Tool__CusFilter__option_select'
                          : '',
                      )}
                      onClick={() => {                        
                        let newVal = [...state.selectedItem.allergen];
                        const isSelected = newVal.find(f => f === e.id);
                        if (isSelected) {
                          const findIndex = newVal.findIndex(f => f === e.id);
                          newVal.splice(findIndex, 1);
                        } else {
                          newVal.push(e.id);
                        }
                        dispatch({
                          type: 'UPDATE_STATE',
                          payload: [{key: 'selectedItem', val:{...state.selectedItem,allergen:newVal.sort()}}]
                        });
                      }}
                    >
                      <span>{e.name}</span>
                    </a>
                  ));
                })()}
                </div>
              <hr style={{marginTop: "8px", marginBottom: "8px"}}/>
                <div className="Tool__CusFilter__subtitle pb-2"><FormattedMessage id="popup.vegan" /></div>
                <div className="mb-1">
                {(() => {
                  if (!veganList) return null;
                  return veganList.map((e, index) => (
                    <a
                      key={index}
                      className={cls(
                        'Tool__CusFilter_Vegan_option p-1 row align-items-center justify-content-center',
                        state.selectedItem.vegan.find(f => f === e.id)
                          ? 'Tool__CusFilter_Vegan_option_select'
                          : '',
                      )}
                      onClick={() => {                       
                        let newVal = [...state.selectedItem.vegan];
                        const isSelected = newVal.find(f => f === e.id);
                        if (isSelected) {
                          newVal = [];
                        } else {
                          newVal = [];
                          newVal.push(e.id);
                        }
                        dispatch({
                          type: 'UPDATE_STATE',
                          payload: [{key: 'selectedItem', val:{...state.selectedItem,vegan:newVal.sort()}}]
                        });
                      }}
                    >
                      <span>{e.name}</span>
                    </a>
                  ));
                })()}
                </div>
            </PerfectScrollbar>
          </div>
          <div className="row align-items-center justify-content-center my-2">
            <div className='col-6 col-lg-3'>
              <CusButton.White
                children={
                  <FormattedMessage id="popup.buttonBack" />
                }
                className="btn-block py-2 addmeal-back"
                onClick={() => {
                  onClose();
                }}
              />
            </div>
            <div className='col-6 col-lg-3'>
              <CusButton.Red
                children={
                  <FormattedMessage id="popup.buttonConfirm" />
                }
                className="btn-block py-2 addmeal-confirm"
                onClick={() => {
                  onSelectItem(state.selectedItem);
                  onClose();
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default Tool__CusFilter;
